import * as Ajax from '../ajax/Ajax';
import moment from "moment-timezone";
import "../models/session/SessionDetailResultModel";
/**
 * セッションタイムアウトを確認します。
 *
 * @param fn ファンクション
 */

export function Check(fn) {
  Ajax.Post("SessionApi/Check", {}, Ajax.ModelResult(fn));
}
/**
 *
 * @param sessionId
 * @param myExpanded
 * @param shareExpanded
 * @param otherExpanded
 * @param shareOwnersExpanded
 * @param otherOwnersExpanded
 * @param includePastMeetings
 */

export function Filter(sessionId, myExpanded, shareExpanded, otherExpanded, shareOwnersExpanded, otherOwnersExpanded, includePastMeetings, fn) {
  Ajax.Post("SessionApi/Filter", {
    sessionId: sessionId,
    myExpanded: myExpanded,
    shareExpanded: shareExpanded,
    otherExpanded: otherExpanded,
    shares: shareOwnersExpanded,
    others: otherOwnersExpanded,
    includePastMeetings: includePastMeetings
  }, Ajax.ModelResult(fn));
}
/**
 * 一覧を取得します。
 *
 * @param isAsync 非同期オプション
 * @param fn ファンクション
 */

export function Query(isAsync, fn) {
  if (isAsync) {
    Ajax.Post("SessionApi/QueryAsync", {}, Ajax.ModelResult(fn));
  } else {
    Ajax.Post("SessionApi/Query", {}, Ajax.ModelResult(fn));
  }
}
/**
 * 詳細を取得します。
 *
 * @param sessionId 会議ＩＤ
 * @param isAsync 非同期オプション
 * @param fn ファンクション
 */

export function QueryDetail(sessionId, isAsync, fn) {
  if (isAsync) {
    Ajax.Post("SessionApi/QueryDetailAsync", {
      sessionId: sessionId
    }, Ajax.ModelResult(fn));
  } else {
    Ajax.Post("SessionApi/QueryDetail", {
      sessionId: sessionId
    }, Ajax.ModelResult(fn));
  }
}
/**
 * 会議を追加します。
 *
 * @param sessionName 会議名
 * @param startDateTime 開始日
 * @param endDateTime 終了日
 * @param sceneModelName シーンモデル名
 * @param sceneImageName シーンイメージ名
 * @param targetFolderName ターゲットフォルダ名
 * @param fn ファンクション
 */

export function AddSession(sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, fn) {
  Ajax.Post("SessionApi/AddSession", {
    sessionName: sessionName,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    sceneModelName: sceneModelName,
    sceneImageName: sceneImageName,
    targetFolderName: targetFolderName
  }, Ajax.ModelResult(fn));
}
/**
 * 会議を更新します。
 *
 * @param sessionId 会議ＩＤ
 * @param sessionName 会議名
 * @param startDateTime 開始日
 * @param endDateTime 終了日
 * @param sceneModelName シーンモデル名
 * @param sceneImageName シーンイメージ名
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifySession(sessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, updateDateTime, fn) {
  Ajax.Post("SessionApi/ModifySession", {
    sessionId: sessionId,
    sessionName: sessionName,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    sceneModelName: sceneModelName,
    sceneImageName: sceneImageName,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 会議を削除します。
 *
 * @param sessionId 会議ＩＤ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteSession(sessionId, updateDateTime, fn) {
  Ajax.Post("SessionApi/DeleteSession", {
    sessionId: sessionId,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * テンプレートから会議を作成します。
 *
 * @param baseSessionId テンプレート会議ID
 * @param sessionName 会議名
 * @param startDateTime 開始日
 * @param endDateTime 終了日
 * @param sceneModelName シーンモデル名
 * @param sceneImageName シーンイメージ名
 * @param targetFolderName ターゲットフォルダ名
 * @param fn ファンクション
 */

export function CopyNewSession(baseSessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, fn) {
  Ajax.Post("SessionApi/CopyNewSession", {
    baseSessionId: baseSessionId,
    sessionName: sessionName,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    sceneModelName: sceneModelName,
    sceneImageName: sceneImageName,
    targetFolderName: targetFolderName
  }, Ajax.ModelResult(fn));
}
/**
 * 会議をコピーします。
 *
 * @param baseSessionId コピー元会議ID
 * @param sessionName 会議名
 * @param startDateTime 開始日
 * @param endDateTime 終了日
 * @param sceneModelName シーンモデル名
 * @param sceneImageName シーンイメージ名
 * @param targetFolderName ターゲットフォルダ名
 * @param useState 保存状態利用
 * @param useMember 保存メンバー利用
 * @param fn ファンクション
 */

export function CopySession(baseSessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, useState, useMember, fn) {
  Ajax.Post("SessionApi/CopySession", {
    baseSessionId: baseSessionId,
    sessionName: sessionName,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    sceneModelName: sceneModelName,
    sceneImageName: sceneImageName,
    targetFolderName: targetFolderName,
    useState: useState,
    useMember: useMember
  }, Ajax.ModelResult(fn));
}
/**
 * 地形情報の登録を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param latitude 緯度
 * @param longitude 経度
 * @param level 表示範囲
 * @param fn ファンクション
 */

export function EntryTerrain(sessionId, materialFileName, latitude, longitude, level, fn) {
  Ajax.Post("SessionApi/EntryTerrain", {
    sessionId: sessionId,
    materialFileName: materialFileName,
    latitude: latitude,
    longitude: longitude,
    level: level
  }, Ajax.ModelResult(fn));
}
/**
 * 素材（オーサリング）情報の登録を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param fn ファンクション
 */

export function EntryAuthoringMaterial(sessionId, materialFileName, fn) {
  Ajax.Post("SessionApi/EntryAuthoringMaterial", {
    sessionId: sessionId,
    materialFileName: materialFileName
  }, Ajax.ModelResult(fn));
}
/**
 * メンバーを取得します。
 *
 * @param sessionId 会議ＩＤ
 * @param fn ファンクション
 */

export function GetMember(sessionId, fn) {
  Ajax.Post("SessionApi/GetMember", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * メンバーを更新します。
 *
 * @param sessionId 会議ＩＤ
 * @param targetArray ユーザー配列
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyMember(sessionId, targetArray, updateDateTime, fn) {
  Ajax.Post("SessionApi/ModifyMember", {
    sessionId: sessionId,
    targetArray: targetArray,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 素材を登録します。
 *
 * @param sessionId 会議ＩＤ
 * @param fileName ファイル名
 * @param itemNameArray アイテム名配列
 * @param fn ファンクション
 */

export function AddMaterial(sessionId, fileName, itemNameArray, fn) {
  Ajax.Post("SessionApi/AddMaterial", {
    sessionId: sessionId,
    fileName: fileName,
    itemNameArray: itemNameArray
  }, Ajax.ModelResult(fn));
}
/**
 * 素材を更新します。
 *
 * @param sessionId 会議ＩＤ
 * @param fileNameArray ファイル名配列
 * @param fn ファンクション
 */

export function ModifyMaterial(sessionId, fileName, itemNameArray, fn) {
  Ajax.Post("SessionApi/ModifyMaterial", {
    sessionId: sessionId,
    fileName: fileName,
    itemNameArray: itemNameArray
  }, Ajax.ModelResult(fn));
}
/**
 * 素材を削除します。
 *
 * @param sessionId 会議ＩＤ
 * @param fileNameArray ファイル名配列
 * @param fn ファンクション
 */

export function DeleteMaterial(sessionId, fileNameArray, fn) {
  Ajax.Post("SessionApi/DeleteMaterial", {
    sessionId: sessionId,
    fileNameArray: fileNameArray
  }, Ajax.ModelResult(fn));
}
/**
 * 素材の表示オプションを設定します。
 *
 * @param sessionId 会議ＩＤ
 * @param fileNameArray ファイル名配列
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DisplayOptionsSettingMaterial(sessionId, fileNameArray, updateDateTime, fn) {
  Ajax.Post("SessionApi/DisplayOptionsSettingMaterial", {
    sessionId: sessionId,
    fileNameArray: fileNameArray,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 素材を一般利用者に共有設定します。
 *
 * @param sessionId 会議ＩＤ
 * @param fileNameArray ファイル名配列
 * @param canDownload ダウンロード許可フラグ
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ShareSettingMaterial(sessionId, fileNameArray, canDownload, updateDateTime, fn) {
  Ajax.Post("SessionApi/ShareSettingMaterial", {
    sessionId: sessionId,
    fileNameArray: fileNameArray,
    canDownload: canDownload,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 素材をリダクション要求します。
 *
 * @param sessionId 会議ＩＤ
 * @param reductionRate リダクション率
 * @param fileNameArray ファイル名配列
 * @param fn ファンクション
 */

export function UpdateMaterial(sessionId, reductionRate, fileNameArray, fn) {
  Ajax.Post("SessionApi/UpdateMaterial", {
    sessionId: sessionId,
    reductionRate: reductionRate,
    fileNameArray: fileNameArray
  }, Ajax.ModelResult(fn));
}
/**
 * メールを送信します。
 *
 * @param sessionId 会議ＩＤ
 * @param notified 通知状態
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function SendMail(sessionId, notified, updateDateTime, fn) {
  Ajax.Post("SessionApi/SendMail", {
    sessionId: sessionId,
    notified: notified,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 公開状態を切り替えます。
 *
 * @param sessionId 会議ＩＤ
 * @param published 公開状態
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyPublished(sessionId, published, updateDateTime, fn) {
  Ajax.Post("SessionApi/ModifyPublished", {
    sessionId: sessionId,
    published: published,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * テンプレート利用状態を切り替えます。
 *
 * @param sessionId 会議ＩＤ
 * @param templateUsed テンプレート利用状態
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyTemplateUsed(sessionId, templateUsed, updateDateTime, fn) {
  Ajax.Post("SessionApi/ModifyTemplateUsed", {
    sessionId: sessionId,
    templateUsed: templateUsed,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * 会議テンプレート名(Room name)一覧取得
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetTemplateNameList(sessionId, fn) {
  Ajax.Post("SessionApi/GetTemplateNameList", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * 素材更新履歴一覧を取得します。
 *
 * @param sessionId 会議ID
 * @param searchWord 検索ワード
 * @param startRow 開始行
 * @param pageSize ページサイズ
 * @param fn ファンクション
 */

export function QueryMaterialHistory(sessionId, searchWord, startRow, pageSize, fn) {
  Ajax.Post("SessionApi/QueryMaterialHistory", {
    sessionId: sessionId,
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * 会議活動履歴一覧を取得します。
 *
 * @param sessionId 会議ID
 * @param searchWord 検索ワード
 * @param startRow 開始行
 * @param pageSize ページサイズ
 * @param fn ファンクション
 */

export function QueryActionsHistory(sessionId, searchWord, startRow, pageSize, fn) {
  Ajax.Post("SessionApi/QueryActionsHistory", {
    sessionId: sessionId,
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * タイムラインシーケンス情報を取得します。
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetTimeline(sessionId, fn) {
  Ajax.Post("SessionApi/GetTimeline", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * タイムラインシーケンス情報を設定します。
 *
 * @param timelineModel タイムライン情報
 * @param fn ファンクション
 */

export function SetTimeline(timelineModel, fn) {
  Ajax.Post("SessionApi/SetTimeline", {
    timelineModel: timelineModel
  }, Ajax.ModelResult(fn));
}
/**
 * タイムラインインタラクション情報を取得します。
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetTimelineForInteraction(sessionId, fn) {
  Ajax.Post("SessionApi/GetTimelineForInteraction", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * タイムラインインタラクション情報を設定します。
 *
 * @param timelineModel タイムライン情報
 * @param fn ファンクション
 */

export function SetTimelineForInteraction(timelineModel, fn) {
  Ajax.Post("SessionApi/SetTimelineForInteraction", {
    timelineModel: timelineModel
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（メッセージ）を追加します。
 *
 * @param uploadMessageMaterials 会議素材（メッセージ）
 * @param fn ファンクション
 */

export function AddUploadMessageMaterials(uploadMessageMaterials, fn) {
  Ajax.Post("SessionApi/AddUploadMessageMaterials", {
    uploadMessageMaterials: uploadMessageMaterials
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（メッセージ）を更新します。
 *
 * @param uploadMessageMaterials 会議素材（メッセージ）
 * @param fn ファンクション
 */

export function ModifyUploadMessageMaterials(uploadMessageMaterials, fn) {
  Ajax.Post("SessionApi/ModifyUploadMessageMaterials", {
    uploadMessageMaterials: uploadMessageMaterials
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（メッセージ）を削除します。
 *
 * @param sessionId 会議ID
 * @param messageId メッセージID
 * @param fn ファンクション
 */

export function DeleteUploadMessageMaterials(sessionId, messageId, fn) {
  Ajax.Post("SessionApi/DeleteUploadMessageMaterials", {
    sessionId: sessionId,
    messageId: messageId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（メッセージ）一覧を取得します。
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetUploadMessageMaterialsList(sessionId, fn) {
  Ajax.Post("SessionApi/GetUploadMessageMaterialsList", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（メッセージ）を取得します。
 *
 * @param sessionId 会議ＩＤ
 * @param messageId メッセージID
 * @param fn ファンクション
 */

export function GetUploadMessageMaterials(sessionId, messageId, fn) {
  Ajax.Post("SessionApi/GetUploadMessageMaterials", {
    sessionId: sessionId,
    messageId: messageId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）を追加します。
 *
 * @param uploadDataMaterials 会議素材（データ）
 * @param fn ファンクション
 */

export function AddUploadDataMaterials(uploadDataMaterials, fn) {
  Ajax.Post("SessionApi/AddUploadDataMaterials", {
    uploadDataMaterials: uploadDataMaterials
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）を更新します。
 *
 * @param uploadDataMaterials 会議素材（データ）
 * @param fn ファンクション
 */

export function ModifyUploadDataMaterials(uploadDataMaterials, fn) {
  Ajax.Post("SessionApi/ModifyUploadDataMaterials", {
    uploadDataMaterials: uploadDataMaterials
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）を複製します。
 *
 * @param sessionId 会議ID
 * @param baseDataId メッセージID
 * @param dataId メッセージID
 * @param fn ファンクション
 */

export function CopyUploadDataMaterials(sessionId, baseDataId, dataId, fn) {
  Ajax.Post("SessionApi/CopyUploadDataMaterials", {
    sessionId: sessionId,
    baseDataId: baseDataId,
    dataId: dataId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）を削除します。
 *
 * @param sessionId 会議ID
 * @param dataId メッセージID
 * @param fn ファンクション
 */

export function DeleteUploadDataMaterials(sessionId, dataId, fn) {
  Ajax.Post("SessionApi/DeleteUploadDataMaterials", {
    sessionId: sessionId,
    dataId: dataId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）一覧を取得します。
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetUploadDataMaterialsList(sessionId, fn) {
  Ajax.Post("SessionApi/GetUploadDataMaterialsList", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議素材（データ）を取得します。
 *
 * @param sessionId 会議ＩＤ
 * @param dataId メッセージID
 * @param fn ファンクション
 */

export function GetUploadDataMaterials(sessionId, dataId, fn) {
  Ajax.Post("SessionApi/GetUploadDataMaterials", {
    sessionId: sessionId,
    dataId: dataId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議シーンを取得します。
 *
 * @param targetFolderName ターゲットフォルダ名
 * @param sceneImageName シーンイメージ名
 * @param fn ファンクション
 */

export function GetScene(targetFolderName, sceneImageName, fn) {
  Ajax.Post("SessionApi/GetScene", {
    targetFolderName: targetFolderName,
    sceneImageName: sceneImageName
  }, Ajax.ModelResult(fn));
}
/**
 * 会議シーン一覧を取得します。
 *
 * @param baseSessionId 会議ID
 * @param targetFolderName ターゲットフォルダ名
 * @param fn ファンクション
 */

export function GetSceneList(baseSessionId, targetFolderName, fn) {
  Ajax.Post("SessionApi/GetSceneList", {
    baseSessionId: baseSessionId,
    targetFolderName: targetFolderName
  }, Ajax.ModelResult(fn));
}
/**
 * 会議シーンのサムネイルを取得します。
 *
 * @param baseSessionId 会議ID
 * @param targetFolderName ターゲットフォルダ名
 * @param sceneImageName シーンイメージ名
 * @param canOverride オーバーライド可否フラグ
 * @param i 行インデックス
 * @param j 列インデックス
 * @param fn ファンクション
 */

export function GetSceneThubnail(baseSessionId, targetFolderName, sceneImageName, canOverride, i, j, type, fn) {
  var data = new FormData();
  data.append("baseSessionId", baseSessionId);
  data.append("targetFolderName", targetFolderName);
  data.append("sceneImageName", sceneImageName);
  data.append("canOverride", String(canOverride));
  return Ajax.SceneImage("SessionApi/GetSceneImageThumbnail", data, i, j, type, fn);
}
/**
 * マテリアルアップロード処理
 */

export var UploadMaterial = function UploadMaterial(sessionId, uploadMaterial, fn) {
  var formData = new FormData();
  formData.append("sessionId", String(sessionId));
  uploadMaterial.map(function (x) {
    formData.append("UploadMaterial", x.Blob, x.FileName);
  });
  Ajax.Upload("SessionApi/UploadMaterial", formData, fn);
};
/**
 * 会議ポータル一覧取得
 *
 * @param sessionId 会議ID
 * @param fn ファンクション
 */

export function GetSessionPortalList(sessionId, fn) {
  Ajax.Post("SessionApi/GetSessionPortalList", {
    sessionId: sessionId
  }, Ajax.ModelResult(fn));
}
/**
 * ポータルの登録を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param privateModeOnly 強制プライベートモードフラグ
 * @param fn ファンクション
 */

export function EntryPortal(sessionId, materialFileName, privateModeOnly, fn) {
  Ajax.Post("SessionApi/EntryPortal", {
    sessionId: sessionId,
    materialFileName: materialFileName,
    privateModeOnly: privateModeOnly
  }, Ajax.ModelResult(fn));
}
/**
 * ストリーミングの登録を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param fn ファンクション
 */

export function EntryStreaming(sessionId, materialFileName, fn) {
  Ajax.Post("SessionApi/EntryStreaming", {
    sessionId: sessionId,
    materialFileName: materialFileName
  }, Ajax.ModelResult(fn));
}
/**
 * リダクション率を設定します。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param reductionRate リダクション率
 * @param fn ファンクション
 */

export function SetReduction(sessionId, materialFileName, reductionRate, fn) {
  Ajax.Post("SessionApi/SetReduction", {
    sessionId: sessionId,
    materialFileName: materialFileName,
    reductionRate: reductionRate
  }, Ajax.ModelResult(fn));
}
/**
 * 再生モードを設定します。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param playbackMode 再生モード
 * @param fn ファンクション
 */

export function SetPlaybackMode(sessionId, materialFileName, playbackMode, fn) {
  Ajax.Post("SessionApi/SetPlaybackMode", {
    sessionId: sessionId,
    materialFileName: materialFileName,
    playbackMode: playbackMode
  }, Ajax.ModelResult(fn));
}
/**
 * リトライ要求を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param fn ファンクション
 */

export function RequestRetry(sessionId, materialFileName, fn) {
  Ajax.Post("SessionApi/RequestRetry", {
    sessionId: sessionId,
    materialFileName: materialFileName
  }, Ajax.ModelResult(fn));
}
/**
 * キャンセル要求を行います。
 *
 * @param sessionId 会議ＩＤ
 * @param materialFileName マテリアル名
 * @param fn ファンクション
 */

export function RequestCancel(sessionId, materialFileName, fn) {
  Ajax.Post("SessionApi/RequestCancel", {
    sessionId: sessionId,
    materialFileName: materialFileName
  }, Ajax.ModelResult(fn));
}
/**
 * 組織オプション情報を取得します。
 *
 * @param fn ファンクション
 */

export function GetOrganizationOptions(fn) {
  Ajax.Post("SessionApi/GetOrganizationOptions", {}, Ajax.ModelResult(fn));
}